export default "__VITE_ASSET__DhmwA14s__"